module.exports = __webpack_public_path__ + "img/menu-1.35279213.svg";